import { Link, useLocation } from '@tanstack/react-router';
import { menuItems } from '../sidelinks';
import Tooltip from '../../common/Tooltip';

interface MenuLinksProps {
  isOpen: boolean;
}

export const MenuLinks: React.FC<MenuLinksProps> = ({ isOpen }) => {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center gap-[8px] mt-[8px]">
      {menuItems.map((item, index) => {
        const isActive = location.pathname === item.path;
        const linkContent = (
          <Link
            key={index}
            to={item.path}
            data-menu-item={item.label.toLowerCase().replace(' ', '-')}
            className={`
              flex items-center
              w-[238px] h-[28px]
              rounded-[4px]
              transition-all duration-200
              ${isActive ? 'bg-[#EEEEEE]' : 'hover:bg-[#F5F5F5]'}
              ${isOpen ? 'w-[238px] px-[6px]' : 'w-[24px] justify-center'}
            `}
          >
            <span className={`
              flex items-center justify-center text-[#222222]
            `}>
              <item.icon className="w-[14px] h-[14px]" />
            </span>
            {isOpen && (
              <span className={`
                ml-[8px] font-light text-[14px] text-[#222222]
              `}>
                {item.label}
              </span>
            )}
          </Link>
        );

        return !isOpen ? (
          <Tooltip key={index} text={item.label}>
            {linkContent}
          </Tooltip>
        ) : (
          linkContent
        );
      })}
    </div>
  );
}; 